/**
 * @param {Date} [referenceDate]
 * @returns {string}
 */
export function getMaxBirthDateIso(referenceDate = new Date()) {
  const year = referenceDate.getFullYear() - 16;
  const month = String(referenceDate.getMonth() + 1).padStart(2, '0');
  const day = String(referenceDate.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/**
 * Oldest accepted birth date: 120 years before the reference day.
 * @param {Date} [referenceDate]
 * @returns {string}
 */
export function getMinBirthDateIso(referenceDate = new Date()) {
  const year = referenceDate.getFullYear() - 120;
  const month = String(referenceDate.getMonth() + 1).padStart(2, '0');
  const day = String(referenceDate.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/**
 * @param {string | undefined | null} value
 * @param {Date} [referenceDate]
 * @returns {boolean}
 */
export function isValidBirthDate(value, referenceDate = new Date()) {
  return getBirthDateValidationError(value, referenceDate) === null;
}

/**
 * @param {string | undefined | null} value
 * @param {Date} [referenceDate]
 * @returns {string | null}
 */
export function getBirthDateValidationError(value, referenceDate = new Date()) {
  if (!value) {
    return 'La fecha de nacimiento es obligatoria.';
  }

  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    return 'Introduce una fecha válida.';
  }

  const [year, month, day] = value.split('-').map(Number);
  const parsedDate = new Date(year, month - 1, day);

  if (
    parsedDate.getFullYear() !== year
    || parsedDate.getMonth() !== month - 1
    || parsedDate.getDate() !== day
  ) {
    return 'Introduce una fecha válida.';
  }

  if (value > getMaxBirthDateIso(referenceDate)) {
    return 'Debes tener al menos 16 años para registrarte.';
  }

  if (value < getMinBirthDateIso(referenceDate)) {
    return 'La fecha de nacimiento no puede ser de hace más de 120 años.';
  }

  return null;
}
